// ==================== TIME PERIOD (Dashboard tabs + Add Widget modal) ====================

export const TIME_PERIOD_MAP = {
  "Last 7 days": "last_7_days",
  "Last 30 days": "last_30_days",
  "Last 90 days": "last_90_days",
  "This month": "this_month",
  "This year": "this_year",
  "Last year": "last_year",
  "Today": "today",
  "Yesterday": "yesterday",
  "Custom": "custom"
}

export const TIME_PERIODS = Object.keys(TIME_PERIOD_MAP)

export const CUSTOM_PERIOD = "custom"

export const DEFAULT_PERIOD_LABEL = "from last month"
export const SPECIFIC_DATES_LABEL = "ai_dashboard.period_specific_dates"

// Reverse map: API period value → display label (derived from TIME_PERIOD_MAP)
export const PERIOD_MAP_REVERSE = Object.fromEntries(
  Object.entries(TIME_PERIOD_MAP).map(([label, val]) => [val, label])
)

// Dashboard tab config — "Custom" opens a RangePicker
export const DATE_FILTER_OPTIONS = TIME_PERIODS
export const DATE_RANGE_FILTERS = ["Custom"]
export const DATE_SINGLE_FILTERS = []

// Forward map: display label → API period value
// Forward map alias kept for backwards compat — same as TIME_PERIOD_MAP
export const PERIOD_MAP = TIME_PERIOD_MAP

// ==================== KPI ====================

export const KPI_KEYS = ["gross_revenue", "expenses", "net_profit", "total_bookings", "cancellations"]

// ==================== WIDGET LAYOUT ====================

export const WIDGET_LAYOUT = {
  "booking-availability":   { colSpan: 1, rowSpan: 1 },
  "annual-summary":         { colSpan: 2, rowSpan: 2 },
  "revenue-trend":          { colSpan: 1, rowSpan: 1 },
  "bookings-by-experience": { colSpan: 1, rowSpan: 1 },
  "top-customers":          { colSpan: 1, rowSpan: 1 },
  "top-experiences":        { colSpan: 1, rowSpan: 1 }
}

// Maps API chart_title → local widget component ID
export const CHART_TITLE_TO_WIDGET_ID = {
  "Revenue Trend": "revenue-trend",
  "Top Customers": "top-customers",
  "Top Clients": "top-customers",
  "Top Clients by Revenue": "top-customers",
  "Top Experiences": "top-experiences",
  "Top Performing Experiences": "top-experiences",
  "Booking Availability": "booking-availability",
  "Annual Summary": "annual-summary",
  "Bookings by Experience": "bookings-by-experience",
  "Bookings by Experience Type": "bookings-by-experience",
  "Revenue by Experience Type": "bookings-by-experience"
}

// ==================== CHAT ====================

export const getInitialChatMessages = (t) => [
  {
    id: 1,
    sender: "ai",
    text: t("ai_dashboard.chat_greeting"),
    time: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  }
]

// ==================== CHART COLORS ====================

export const CHART_COLORS = {
  blue: "#1677ff",
  blueAlt: "#3b82f6",
  amber: "#f59e0b",
  green: "#22c55e",
  purple: "#a855f7",
  pink: "#ec4899",
  orange: "#f97316",
  gridLine: "#f5f5f5",
  border: "#e5e7eb",
  label: "#6b7280",
}

export const CHART_TYPES = {
  LINE: "line",
  AREA: "area",
  BAR: "bar",
  STACKED_BAR: "stacked_bar",
  STACKED_BAR_ALT: "stacked-bar",
  PIE: "pie",
  DONUT: "donut",
  FUNNEL: "funnel",
  HEATMAP: "heatmap",
  RADAR: "radar",
  LIST: "list",
  STAT: "stat",
  LEGEND: "legend"
}

export const DONUT_COLORS = ["#f59e0b", "#22c55e", "#a855f7", "#ec4899", "#3b82f6", "#9ca3af", "#f97316", "#06b6d4", "#84cc16", "#e11d48"]
export const AVATAR_COLORS = ["#3b82f6", "#8b5cf6", "#10b981", "#f59e0b", "#ec4899"]
export const EXP_THUMB_COLORS = ["#fed7aa", "#d1fae5", "#dbeafe", "#fce7f3", "#ede9fe"]
export const ANNUAL_SUMMARY_COLORS = { income: "#3b82f6", expenses: "#FF5119" }

// ==================== CHART OPTIONS ====================

export const lineChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { datalabels: { display: false }, legend: { display: false }, tooltip: { mode: "index", intersect: false } },
  scales: {
    x: { grid: { display: false }, border: { display: false } },
    y: { grid: { color: CHART_COLORS.gridLine }, border: { display: false }, ticks: { maxTicksLimit: 5 } }
  }
}

export const doughnutOptions = {
  responsive: true,
  maintainAspectRatio: false,
  cutout: "65%",
  plugins: { datalabels: { display: false }, legend: { display: false } }
}

export const barChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    datalabels: { display: false },
    legend: { position: "top", align: "end", labels: { usePointStyle: true, boxWidth: 8, font: { size: 12 } } },
    tooltip: { mode: "index", intersect: false }
  },
  scales: {
    x: { grid: { display: false }, border: { display: false } },
    y: { grid: { color: CHART_COLORS.gridLine }, border: { display: false }, ticks: { maxTicksLimit: 5 } }
  }
}
